import { useController, useFormContext } from "react-hook-form";
import FloatLabel from "./FloatLabel";
import ReactDatePicker from "./ReactDatePicker";
import ErrorLabel from "./ErrorLabel";
import { isValidDate } from "../../utils/helper";
import { useEffect } from "react";

export default function DatePickerControl({ control, name, label, isDisabled = false, isRequired = false, rules, ...rest }) {
	const { setValue } = useFormContext();

	const {
		field: { value, ...field },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: { required: isRequired && `${label} is required`, ...rules },
	});

	useEffect(() => {
		!isValidDate(value) && setValue(field.name, isValidDate(value));
		//eslint-disable-next-line
	}, [value, field]);

	return (
		<FloatLabel label={label} isRequired={isRequired}>
			<ReactDatePicker value={isValidDate(value)} {...field} disabled={isDisabled} {...rest} />
			<ErrorLabel>{error?.message}</ErrorLabel>
		</FloatLabel>
	);
}
